import axios from "axios";
import { API_URL } from "../../constants";

export const ArchiveEventApi = async (body,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.post(API_URL + "event/archive_post",body, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}